module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-12"
  }, [(_vm.$store.getters.detailedRoster) ? _c('div', [_vm._m(0), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), (_vm.team) ? _c('tbody', {
    staticClass: "roster"
  }, [_vm._l((_vm.team.players), function(p) {
    return _c('tr', {
      class: [_vm.canRemovePlayerFromRevokeList(p.id) ? 'barre' : '', '']
    }, [_c('td', [_vm._v(_vm._s(p.num))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.ref_roster_line))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.M))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.F))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.Ag))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.Ar))]), _vm._v(" "), _c('td', [_vm._l((p.skills), function(skill) {
      return _c('span', [_vm._v("\n                " + _vm._s(skill.name) + ",\n             ")])
    }), _vm._v(" "), _vm._l((p.upgrades), function(up) {
      return (p.upgrades.length) ? _c('span', {
        class: _vm.getUpgradeStyle(up)
      }, [_vm._v("\n                                      " + _vm._s(_vm.getUpgradeName(up)) + ",\n                                   ")]) : _vm._e()
    }), _vm._v(" "), (p.downgrades) ? _c('span', {
      staticClass: "upgrade down"
    }, [_vm._v("\n                                      " + _vm._s(_vm.getDowngrades(p)) + ",\n                                   ")]) : _vm._e(), _vm._v(" "), _vm._l((p.customizations), function(cust) {
      return (p.customizations && p.customizations.length) ? _c('div', {
        staticClass: "upgrade stats"
      }, _vm._l((cust.skills), function(skill) {
        return (cust.skills) ? _c('span', [_vm._v(_vm._s(skill.name) + ", ")]) : _vm._e()
      }), 0) : _vm._e()
    })], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.is_leaving(p.id)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.played_seasons(p.id)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formerPlayerCost(p.id)) + " 000")]), _vm._v(" "), _c('td', {
      staticClass: "action"
    }, [_c('button', {
      class: [_vm.canRemovePlayerFromRevokeList(p.id) ? '' : 'deactivated', 'small action'],
      attrs: {
        "id": p.id,
        "disabled": _vm.canRemovePlayerFromRevokeList(p.id) === false
      },
      on: {
        "click": function($event) {
          return _vm.removePlayerFromRevokeList(p.id)
        }
      }
    }, [_vm._m(2, true)])]), _vm._v(" "), _c('td', {
      staticClass: "action"
    }, [_c('button', {
      class: [_vm.canAddPlayerToRevokeList(p.id) ? '' : 'deactivated', 'small alert action'],
      attrs: {
        "id": p.id,
        "disabled": _vm.canAddPlayerToRevokeList(p.id) === false
      },
      on: {
        "click": function($event) {
          return _vm.addPlayerToRevokeList(p.id)
        }
      }
    }, [_vm._m(3, true)])])])
  }), _c('tr', [_c('td', {
    staticClass: "sous-total right",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("Budget Anciens Joueurs")]), _vm._v(" "), _c('td', {
    staticClass: "sous-total"
  }), _vm._v(" "), _c('td', {
    staticClass: "sous-total"
  }, [_vm._v(_vm._s(_vm.totalPlayerCost) + " 000 pO")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("pour " + _vm._s(_vm.totalHiredPlayer) + " joueurs")])])], 2) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-12 inner-title"
  }, [_vm._v("\n          Gestion des anciens Joueurs:\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "large-12 inner-subtitle"
  }, [_vm._v("\n          Choisissez les joueurs que vous voulez garder, et virez les autres.\n          Par défaut, tous les joueurs sont gardés\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {}, [_c('th', {
    attrs: {
      "width": "60"
    }
  }, [_vm._v("n")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "150"
    }
  }, [_vm._v("Nom")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Position")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10"
    }
  }, [_vm._v("M")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10"
    }
  }, [_vm._v("F")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10"
    }
  }, [_vm._v("Ag")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10"
    }
  }, [_vm._v("Ar")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "250"
    }
  }, [_vm._v("Compétences")]), _vm._v(" "), _c('th', {
    attrs: {
      "with": "20"
    }
  }, [_vm._v("Départ")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "50"
    }
  }, [_vm._v("Nb Saisons")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Cout de réachat")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-trash-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2709b55e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/create/former-player-chooser.vue
// module id = 724
// module chunks = 0